import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getVendorListApi } from '~/features/vendor/api/get-vendor-list.api';
import { getVendorApi } from '~/features/vendor/api/get-vendor.api';

import type { Vendor } from '~/features/vendor/types/vendor.type';

export interface VendorState {
  isLoading: boolean;
  list: Vendor[];
  selectedVendor: Vendor | null;
}

const initialState: VendorState = {
  isLoading: false,
  list: [],
  selectedVendor: null,
};

/**
 * 벤더 목록 조회
 */
export const fetchVendorList = createAsyncThunk<Vendor[]>(
  'vendor/fetchList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await getVendorListApi();
      return data.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

/**
 * 벤더 상세 조회
 */
export const fetchVendorDetail = createAsyncThunk<Vendor, number>(
  'vendor/fetchDetail',
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await getVendorApi(id);
      return data.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

const VendorSlice = createSlice({
  initialState,
  name: 'vendor',
  reducers: {
    setSelectedVendor: (state, action) => {
      state.selectedVendor = action.payload;
    },
    resetSelectedVendor: state => {
      state.selectedVendor = null;
    },
    resetVendor: state => {
      state.selectedVendor = null;
      state.list = [];
      state.isLoading = false;
    },
  },
  extraReducers: builder => {
    builder
      // fetchVendorList
      .addCase(fetchVendorList.pending, state => {
        state.isLoading = true;
      })
      .addCase(fetchVendorList.fulfilled, (state, action) => {
        state.list = Array.isArray(action.payload) ? action.payload : [];
        state.isLoading = false;
      })
      .addCase(fetchVendorList.rejected, state => {
        state.isLoading = false;
      })
      // fetchVendorDetail
      .addCase(fetchVendorDetail.pending, state => {
        state.isLoading = true;
      })
      .addCase(fetchVendorDetail.fulfilled, (state, action) => {
        state.selectedVendor = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchVendorDetail.rejected, state => {
        state.isLoading = false;
      });
  },
});

export const { setSelectedVendor, resetSelectedVendor, resetVendor } = VendorSlice.actions;
export default VendorSlice;
